import React, { useEffect, useState } from "react";
import {
  Tree,
  message,
  Form,
  Select,
  DatePicker,
  Input,
  InputNumber,
  Upload,
  Radio,
} from "antd";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import AnalysisApi from "../../api/analysis";
import { deviceApi } from "../../api/newApi";
import StationApi from "../../api/station";
import SystemApi from "@api/sys";
import AssetImg from "../../assets/device.png";
import classnames from "classnames";
import moment from "moment";
import "./index.scss";
import "./list.scss";
import IndicatorPage from "./components/Indicator/IndicatorPage";
import HistoryData from "./components/historyData";
import ServiceabilityRate from "./components/serviceabilityRate";
import DeviceHealth from "../../components/deviceHealth";
import CollectParams from "./components/collectParams";
import BomRecord from "./components/bom";
import { connect } from "react-redux";
const mapStateToProps = (state) => {
  return {
    ...state.Common,
  };
};

const { UPLOADER } = window.globalConfig;

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
};

export default connect(mapStateToProps)(() => {
  const [form] = Form.useForm();
  const [treeData, setTreeData] = useState([]);
  const [info, setInfo] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [materielOpt, setmaterielOpt] = useState([]);
  const [GJLogData, setGJLogData] = useState([]);
  const [showMoreGJData, setshowMoreGJData] = useState(false);
  const [selectProcess, setSelectProcess] = useState({});
  const [unitPic, setUnitPic] = useState("");
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState(0);
  const [deviceId, setDeviceId] = useState();
  const [processUnitId, setProcessUnitId] = useState();
  const [expandedKeys, setExpandedKeys] = useState([]);
  const [deviceClassifyAll, setDeviceClassifyAll] = useState([]);
  const [supplierList, setSupplierList] = useState([]);
  const [stationId, setStationId] = useState();
  const [runStates, setRunStates] = useState([]);
  const [deviceBusinessTypes, setDeviceBusinessTypes] = useState([]);

  useEffect(() => {
    getStations();
    getDeviceClassifyAll();
    selectWithClassifyKeys();
  }, []);

  useEffect(() => {
    if (stationId) {
      supplierAllByStation();
    }
  }, [stationId]);

  const getStations = () => {
    AnalysisApi.getStation().then((res) => {
      if (res.status == 0 && res.data) {
        const list = res.data.map((item) => {
          return {
            ...item,
            title: item.aliasName,
            key: `${item.id}-station`,
            type: "station",
            pid: -1,
          };
        });
        setTreeData(list);
        if (list.length > 0) {
          setExpandedKeys([list[0].key]);
          setStationId(list[0].id);
        }
      }
    });
  };

  const selectWithClassifyKeys = () => {
    SystemApi.selectWithClassifyKeys({
      classifyKeys: ["runStatuts", "deviceBusinessType"],
    }).then((res) => {
      if (res.status !== "0") return;
      const { runStatuts = [], deviceBusinessType = [] } = res.data;
      setRunStates(runStatuts);
      setDeviceBusinessTypes(deviceBusinessType);
    });
  };

  const supplierAllByStation = () => {
    SystemApi.supplierAllByStation({ stationId }).then((res) => {
      if (res.status !== "0") return;
      setSupplierList(res.data);
    });
  };

  const getDeviceClassifyAll = () => {
    SystemApi.deviceClassifyAll({}).then((res) => {
      if (res.status !== "0") return;
      const obj = {};
      res.data.forEach((item) => {
        obj[item.id] = item.classifyName;
      });
      setDeviceClassifyAll(res.data);
    });
  };

  const getMaterielAndprocessunitArr = (stationId) => {
    deviceApi.selectByStationId({ stationId }).then((res) => {
      if (res.status * 1 === 0) {
        setmaterielOpt(res.data.materiels);
      }
    });
  };

  const selectProcessUnitList = async (key) => {
    const res = await AnalysisApi.selectProcessUnitList(key.split("-")[0]);
    if (res.status == 0 && res.data) {
      const arr = res.data.map((item) => {
        return {
          ...item,
          title: item.name,
          key: `${item.id}-process`,
          pid: key,
          type: "process",
        };
      });
      return arr;
    }
    return [];
  };

  const selectDeviceList = async (key, stationId) => {
    const param = {
      pageNum: 1,
      pageSize: 9999,
      processUnitId: key.split("-")[0],
      stationId: stationId.split("-")[0],
    };
    const res = await AnalysisApi.selectDeviceList(param);
    const { data, status } = res;
    if (status == 0 && data.data) {
      const arr = data.data.map((item) => {
        return {
          ...item,
          title: item.deviceName,
          key: `${item.id}-device`,
          pid: key,
          type: "device",
        };
      });
      return arr;
    }
    return [];
  };

  const selectNextDeviceList = async (key) => {
    const param = {
      pageNum: 1,
      pageSize: 9999,
      devId: key.split("-")[0],
    };
    const res = await AnalysisApi.selectNextDeviceList(param);
    const { data, status } = res;
    if (status == 0 && data.data) {
      const arr = data.data.map((item) => {
        return {
          ...item,
          title: item.deviceName,
          key: `${item.id}-device4`,
          pid: key,
          type: "device",
          isLeaf: true,
        };
      });
      return arr;
    }
    return [];
  };

  const updateTreeData = (list, key, children) => {
    return list.map((node) => {
      if (node.key === key) {
        return {
          ...node,
          children,
        };
      }
      if (node.children) {
        return {
          ...node,
          children:
            node.children && updateTreeData(node.children, key, children),
        };
      }
      return node;
    });
  };

  const onLoadData = ({ key, pid, type, children }) =>
    new Promise(async (resolve) => {
      if (children) {
        resolve();
        return;
      }
      let arr = [];
      if (type == "station") {
        arr = await selectProcessUnitList(key);
      } else if (type == "process") {
        arr = await selectDeviceList(key, pid);
      } else if (type == "device") {
        arr = await selectNextDeviceList(key);
      }
      setTreeData((origin) => updateTreeData(origin, key, arr));
      resolve();
    });

  const onSelect = (selectedKeys, { node }) => {
    const key = node.key.split("-")[0];
    if (node.type == "device") {
      getInfos(key);
      getLogDataFn(key);
      setDeviceId(key);
    } else if (node.type == "process") {
      setSelectProcess(node);
      setUnitPic(node.unitPic);
      setProcessUnitId(key);
    } else {
      setSelectProcess({});
      setUnitPic("");
    }
  };

  const getInfos = (id) => {
    deviceApi.getById({ deviceId: id }).then((res) => {
      if (res.status !== "0") return;
      setInfo(res.data);
      setProcessUnitId(res.data.processunitId);
      const {
        materielId,
        deviceModel,
        dossierSpec,
        insTime,
        deviceFactory,
        maintenanceCycle,
        stationId,
        purchaseTime,
      } = res.data;
      form.setFieldsValue({
        ...res.data,
        materielId,
        deviceModel,
        dossierSpec,
        insTime: insTime ? moment(insTime) : undefined,
        purchaseTime: purchaseTime ? moment(purchaseTime) : undefined,
        deviceFactory,
        maintenanceCycle: maintenanceCycle * 1 || undefined,
      });
      getMaterielAndprocessunitArr(stationId);
    });
  };

  const getLogDataFn = (devId) => {
    deviceApi.selectAlarmsByDevId({ devId }).then((res) => {
      if (res.status * 1 == 0) {
        setGJLogData(res.data);
      }
    });
  };

  // 取消编辑按钮
  const cancelEditBtn = () => {
    setIsEdit(false);
  };

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      message.error("你只能上传jpg或png图片格式");
    }
    const isLt5M = file.size / 1024 / 1024 < 5;
    if (!isLt5M) {
      message.error("图片必需小于5M");
    }

    const isId = selectProcess.id ? true : false;
    if (!isId) {
      message.error("请先选择工艺单元");
    }
    return isJpgOrPng && isLt5M && isId;
  };

  const handleChange = (info) => {
    if (info.file.status === "uploading") {
      setLoading(true);
    }
    if (info.file.status === "done") {
      const res = info.file.response;
      if (res.status == "0") {
        updateUnitPic(res.data.url);
      } else {
        setLoading(false);
      }
    }
  };

  const updateUnitPic = (url) => {
    const params = { id: selectProcess.id, unitPic: url };
    StationApi.updateProcessUnit(params)
      .then((res) => {
        setLoading(false);
        if (res.status == "0") {
          setUnitPic(url);
          message.success("上传成功");
          treeData.forEach((item) => {
            if (item.key == selectProcess.pid) {
              item.children &&
                item.children.forEach((subItem) => {
                  if (subItem.id == selectProcess.id) {
                    subItem.unitPic = url;
                  }
                });
            }
          });
          setTreeData(() => {
            return [...treeData];
          });
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const saveBtn = () => {
    form.validateFields().then((values) => {
      const params = {
        ...info,
        ...values,
        insTime: values.insTime.format("YYYY-MM-DD HH:mm:ss"),
        purchaseTime: values.purchaseTime.format("YYYY-MM-DD HH:mm:ss"),
      };
      deviceApi.update(params).then((res) => {
        if (res.status * 1 === 0) {
          message.success("编辑成功");
          setIsEdit(false);
          getInfos(info.id);
        } else {
          message.error(res.data);
        }
      });
    });
  };

  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        上传
      </div>
    </div>
  );

  return (
    <div className="assetsmana-list">
      <div className="dev-tree">
        <Tree
          expandedKeys={expandedKeys}
          showLine
          loadData={onLoadData}
          onSelect={onSelect}
          treeData={treeData}
          height={700}
          onExpand={(keys) => setExpandedKeys(keys)}
        />
      </div>
      <div className="dev-info">
        <div className="dev-info-wrap">
          <div className="detail-tit">
            <h2>工艺单元：{selectProcess.title}</h2>
          </div>
          <div className="detail-content">
            <Upload
              headers={{
                authorization: sessionStorage.getItem("token"),
              }}
              name="file"
              listType="picture-card"
              className="avatar-uploader"
              showUploadList={false}
              action={UPLOADER}
              beforeUpload={beforeUpload}
              onChange={handleChange}
            >
              {unitPic ? (
                <div style={{ width: 102, height: 102 }}>
                  <img
                    src={unitPic}
                    alt="avatar"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </div>
              ) : (
                uploadButton
              )}
            </Upload>
          </div>
          <div className="detail-tit">
            <h2>{info.deviceName}</h2>
          </div>
          <div className="detail-content">
            <div className="base-info-box">
              <div className="info-tit">
                <h6>设备信息</h6>
                <div className="btn-box">
                  {isEdit ? (
                    <>
                      <div className="btn" onClick={() => cancelEditBtn()}>
                        <i className="iconfont iconfanhui"></i>
                        <span>取消</span>
                      </div>
                      <div className="btn" onClick={() => saveBtn()}>
                        <i className="iconfont iconbaocun"></i>
                        <span>保存</span>
                      </div>
                    </>
                  ) : (
                    <div
                      className="btn"
                      onClick={() => {
                        setIsEdit(true);
                      }}
                    >
                      <i className="iconfont iconbianji"></i>
                      <span>修改</span>
                    </div>
                  )}
                </div>
              </div>
              <div className="info-content">
                <div className="img-area">
                  <div className="img-box">
                    <i>编码：{info.deviceNum}</i>
                    <img src={info.attach || AssetImg} alt="加载失败" />
                  </div>
                  <p>
                    {info.updateName}{" "}
                    {info.updateTime && info.updateTime.substr(0, 10)} 录入
                  </p>
                </div>
                <div
                  className={classnames({
                    "form-box": true,
                    detail: !isEdit,
                  })}
                >
                  <Form layout="inline" form={form} {...layout}>
                    <Form.Item
                      label="设备分类"
                      name="deviceClassifyId"
                      rules={[{ required: true, message: "必填!" }]}
                    >
                      <Select
                        placeholder="请选择"
                        size="small"
                        disabled={!isEdit}
                      >
                        {deviceClassifyAll.map((item, idx) => {
                          return (
                            <Select.Option value={item.id} key={item.id}>
                              {item.classifyName}
                            </Select.Option>
                          );
                        })}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      label="设备名称"
                      name="deviceName"
                      rules={[{ required: true, message: "必填!" }]}
                    >
                      <Input
                        disabled={!isEdit}
                        placeholder="请填写设备真实名称"
                        maxLength={50}
                      />
                    </Form.Item>
                    <Form.Item
                      label="设备型号"
                      name="deviceModel"
                      rules={[{ required: true, message: "必填!" }]}
                    >
                      <Input
                        placeholder="请填写设备真实型号"
                        size="small"
                        maxLength={50}
                        disabled={!isEdit}
                      />
                    </Form.Item>
                    <Form.Item label="设备规格" name="dossierSpec">
                      <Input
                        placeholder="请填写设备真实规格"
                        size="small"
                        maxLength={50}
                        disabled={!isEdit}
                      />
                    </Form.Item>
                    <Form.Item
                      label="供应商"
                      name="deviceFactory"
                      rules={[{ required: true, message: "必填!" }]}
                    >
                      <Select disabled={!isEdit} placeholder="请选择供应商">
                        {supplierList.map((item) => {
                          return (
                            <Select.Option value={item.name} key={item.id}>
                              {item.name}
                            </Select.Option>
                          );
                        })}
                      </Select>
                    </Form.Item>
                    <Form.Item label="所属标段" name="belongSection">
                      <Input
                        placeholder="请填写所属标段"
                        size="small"
                        maxLength={50}
                        disabled={!isEdit}
                      />
                    </Form.Item>
                    <Form.Item label="放置位置" name="installAddress">
                      <Input
                        placeholder="请填写放置位置"
                        size="small"
                        maxLength={50}
                        disabled={!isEdit}
                      />
                    </Form.Item>
                    <Form.Item
                      label="购置时间"
                      name="purchaseTime"
                      rules={[{ required: true, message: "必填!" }]}
                    >
                      <DatePicker
                        style={{ width: "100%" }}
                        size="small"
                        disabled={!isEdit}
                        showTime
                      />
                    </Form.Item>
                    <Form.Item label="责任人" name="dutyManager">
                      <Input
                        placeholder="请填写责任人"
                        size="small"
                        maxLength={50}
                        disabled={!isEdit}
                      />
                    </Form.Item>
                    <Form.Item
                      label="设备状态"
                      name="runState"
                      rules={[{ required: true, message: "必填!" }]}
                    >
                      <Select
                        placeholder="请选择设备状态"
                        size="small"
                        disabled={!isEdit}
                      >
                        {runStates.map((item) => {
                          return (
                            <Select.Option value={item.disName} key={item.id}>
                              {item.disName}
                            </Select.Option>
                          );
                        })}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      label="业务类型"
                      name="deviceBusinessType"
                      rules={[{ required: true, message: "必填!" }]}
                    >
                      <Select
                        placeholder="请选择业务类型"
                        size="small"
                        disabled={!isEdit}
                      >
                        {deviceBusinessTypes.map((item) => {
                          return (
                            <Select.Option value={item.disName} key={item.id}>
                              {item.disName}
                            </Select.Option>
                          );
                        })}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      label="投入时间"
                      name="insTime"
                      rules={[{ required: true, message: "必填!" }]}
                    >
                      <DatePicker
                        style={{ width: "100%" }}
                        size="small"
                        disabled={!isEdit}
                        showTime
                      />
                    </Form.Item>
                    <Form.Item
                      label="维保周期"
                      style={{ position: "relative" }}
                    >
                      <>
                        <Form.Item name="maintenanceCycle" noStyle>
                          <InputNumber
                            disabled={!isEdit}
                            placeholder="请输入"
                            type="number"
                            size="small"
                            min={0}
                            style={{ width: "170px" }}
                          />
                        </Form.Item>
                        <span className="dw">月</span>
                      </>
                    </Form.Item>
                    <Form.Item
                      label="物料类型："
                      name="materielId"
                      rules={[{ required: true, message: "必填!" }]}
                    >
                      <Select
                        placeholder="请选择"
                        size="small"
                        disabled={!isEdit}
                      >
                        {materielOpt.map((item, idx) => {
                          return (
                            <Select.Option value={item.id} key={"wl-" + idx}>
                              {item.name}
                            </Select.Option>
                          );
                        })}
                      </Select>
                    </Form.Item>
                    <Form.Item label="所在工艺">
                      {info.processunitName}
                    </Form.Item>
                  </Form>
                </div>
              </div>
            </div>

            <div className="log-area">
              <div style={{ color: "#1890ff", fontSize: 20, marginBottom: 20 }}>
                告警记录
              </div>
              <div className="log-box">
                <div className="head">
                  <div>告警时间</div>
                  <div>结束时间</div>
                  <div>告警信息</div>
                  <div>负责人</div>
                </div>
                <div className="con">
                  {GJLogData.map((item, idx) => {
                    return (
                      (idx < 3 || (idx > 2 && showMoreGJData)) && (
                        <div className="row" key={"log-" + idx}>
                          <div>{item.startTime}</div>
                          <div>{item.endTime}</div>
                          <div>{item.alarmInfo}</div>
                          <div>{item.dutyUserNames}</div>
                        </div>
                      )
                    );
                  })}
                  {GJLogData.length == 0 && (
                    <div className="row">
                      <div
                        style={{
                          textAlign: "center",
                          fontSize: "12px",
                          lineHeight: "50px",
                          color: "#999",
                        }}
                      >
                        - 暂无数据 -
                      </div>
                    </div>
                  )}
                </div>
                {GJLogData.length > 3 && (
                  <div
                    className="foot"
                    onClick={() => setshowMoreGJData(!showMoreGJData)}
                  >
                    <span>{showMoreGJData ? "收起" : "展开"}</span>
                    <i
                      className={classnames({
                        "iconfont iconxiala": true,
                        up: showMoreGJData,
                      })}
                    ></i>
                  </div>
                )}
              </div>
            </div>

            <div className="repair-tip">
              下次保养时间{" "}
              {info.nextMaintainTime && info.nextMaintainTime.substr(0, 10)}
              ，还剩
              <span>
                {info.nextMaintainTime
                  ? moment(info.nextMaintainTime).diff(
                      moment(new Date()),
                      "days"
                    )
                  : "0"}
              </span>
              天
            </div>
          </div>
        </div>
        <Radio.Group
          style={{ width: "100%" }}
          value={type}
          onChange={(e) => setType(e.target.value)}
          optionType="button"
          buttonStyle="solid"
        >
          <Radio.Button value={0}>BOM清单</Radio.Button>
          <Radio.Button value={1}>采集参数</Radio.Button>
          <Radio.Button value={2}>指标设置</Radio.Button>
          <Radio.Button value={3}>历史数据</Radio.Button>
          <Radio.Button value={4}>完好率</Radio.Button>
          <Radio.Button value={5}>健康预测</Radio.Button>
        </Radio.Group>
        {type == 0 && <BomRecord deviceId={deviceId} />}
        {type == 1 && <CollectParams processUnitId={processUnitId} />}
        {type == 2 && (
          <IndicatorPage gatherDevId={deviceId} processUnitId={processUnitId} />
        )}
        {type == 3 && <HistoryData deviceId={deviceId} />}
        {type == 4 && <ServiceabilityRate deviceId={deviceId} />}
        {type == 5 && <DeviceHealth deviceId={deviceId} />}
      </div>
    </div>
  );
});
